"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addResponseTimeLog = addResponseTimeLog;
exports.consoleLog = consoleLog;
exports.createResponseTimePayload = createResponseTimePayload;
exports["default"] = void 0;
var _coreCallback = _interopRequireDefault(require("../core-callback"));
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreLogger = _interopRequireDefault(require("../core-logger"));
var _logLevels = _interopRequireDefault(require("../core-logger/log-levels"));
var _coreNetwork = require("../core-network");
var _excluded = ["networkLogLevel"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */ /**
 * Logging handler supporting console logging and SDK window.postMessage API
 * logging to enclosing DOM log handler in bootstrap component.
 *
 * @module core-log
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */
/**
 * General SDK logging function.
 * - If loggingEnabled then triggers the general.log callback
 * - If consoleLoggingEnabled then writes log line to JS console
 * - If netwoorkLoggingEnabled then writes log to network service
 *
 * @param {string} msg The string to log
 * @param {*} [networkPayload] Optional network payload to log
 */
function log(msg, networkPayload) {
  callbackLog(msg);
  networkLog(msg, networkPayload);
  consoleLog(msg);
}

/**
 * Callback logging function
 * - If loggingEnabled then writes log to callback function
 *
 * @param {string} msg The string to log
 */
function callbackLog(msg) {
  if (_coreConfig["default"].get(_coreConfig["default"].external).loggingEnabled && msg) {
    _coreCallback["default"].invokeParentCallback(_coreCallback["default"].callbacks.generalLog, {
      message: msg
    });
  }
}

/**
 * Console logging function
 * - If consoleLoggingEnabled then writes log line to JS console
 *
 * @param {string} msg The string to log
 */
function consoleLog(msg) {
  if (console && _coreConfig["default"].get(_coreConfig["default"].external).consoleLoggingEnabled && msg) {
    console.log('SDK CORE:' + window.name + ':' + msg); // NOSONAR
  }
}

/**
 * Overrides the success and failure callbacks to add response time logging
 *
 * @param {String} url requested URL
 * @param {Object} opts request options
 */
function addResponseTimeLog(url, opts) {
  var startTime = Date.now();
  var serviceKey = url && "".concat(url.split('/').pop(), "-initTime");
  _coreConfig["default"].get(_coreConfig["default"].internal)[serviceKey] = startTime;
  var cbName = _coreCallback["default"].callbacks.generalLog;
  var originalSuccess = opts.success;
  var originalFailure = opts.failure;
  var basePayload = {
    timestamp: new Date().toISOString(),
    sdk_event_type: cbName
  };
  var sdkResponseTime = _coreConfig["default"].get(_coreConfig["default"].internal)[serviceKey];
  opts.success = function (data, status, response) {
    originalSuccess(data, status, response);
    var serviceKey = response.config && "".concat(response.config.serviceKey, "-initTime");
    var sdkResponseTime = _coreConfig["default"].get(_coreConfig["default"].internal)[serviceKey];
    networkLog(cbName, createResponseTimePayload(_objectSpread(_objectSpread({}, basePayload), {}, {
      response: response,
      context: opts.context || 'default',
      sdk_response_time: sdkResponseTime,
      message: "SUCCESS: ".concat(opts.method, " request made to ").concat(url),
      networkLogLevel: _logLevels["default"].INFO
    })));
  };
  opts.failure = function (response, status, message) {
    originalFailure(response, status, message);
    networkLog(cbName, createResponseTimePayload(_objectSpread(_objectSpread({}, basePayload), {}, {
      response: response,
      context: opts.context || 'default',
      sdk_response_time: sdkResponseTime,
      message: "FAILURE: ".concat(opts.method, " request made to ").concat(url),
      error_code: status
    })));
  };
}
;

/**
 * Response Time log payload creator
 *
 * @param {Object} payload Object with custom payload
 * @return {Object} A basic network payload object
 */
function createResponseTimePayload(payload) {
  var internal = _coreConfig["default"].get(_coreConfig["default"].internal);
  var external = _coreConfig["default"].get(_coreConfig["default"].external);
  var WFRequestID = _coreConfig["default"].get(_coreConfig["default"].internal).WFRequestID;
  return {
    sdk_client_request_id: (0, _coreNetwork.extractClientRequestId)(payload.response),
    sdk_version: internal.sdkInternalVersion || internal.resourceBundleVersion,
    sdk_merchant_number: external.merchantNumber,
    sdk_error_code: payload.error_code,
    sdk_browser_timestamp: new Date().toISOString(),
    sdk_event_type: payload.sdk_event_type,
    sdk_event_context: payload.context,
    sdk_response_time: payload.sdk_response_time,
    sdk_event_description: payload.message,
    networkLogLevel: payload.networkLogLevel,
    sdk_wf_request_id: WFRequestID
  };
}

/**
 * Network logging function
 * - If consoleLoggingEnabled then writes log line to JS console
 *
 * @param {string} msg The callback name
 * @param {*} networkPayload The payload to send on the network
 */
function networkLog(msg, networkPayload) {
  // get the latest session token (stored by core-network)
  var sessionToken = _coreConfig["default"].get(_coreConfig["default"].internal).sessionToken;
  var WFRequestID = _coreConfig["default"].get(_coreConfig["default"].internal).WFRequestID;
  if (_coreConfig["default"].get(_coreConfig["default"].internal).networkLoggingEnabled && networkPayload && sessionToken) {
    var loadTime = _coreConfig["default"].get(_coreConfig["default"].internal).sdkLoadTime;
    var merchNumber = networkPayload.sdk_merchant_number;
    networkPayload = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, networkPayload), loadTime && {
      sdk_load_time: loadTime
    }), merchNumber && {
      sdk_merchant_number: merchNumber.slice(-4)
    }), {}, {
      sdk_wf_request_id: WFRequestID
    });
    var _networkPayload = networkPayload,
      _networkPayload$netwo = _networkPayload.networkLogLevel,
      networkLogLevel = _networkPayload$netwo === void 0 ? _logLevels["default"].ERROR : _networkPayload$netwo,
      rest = _objectWithoutProperties(_networkPayload, _excluded);
    if (networkLogLevel in _logLevels["default"]) {
      var loggerFunction = _coreLogger["default"][networkLogLevel.toLowerCase()];
      loggerFunction({
        message: JSON.stringify(rest)
      });
    }
  }
}
var _default = exports["default"] = {
  log: log,
  callbackLog: callbackLog,
  consoleLog: consoleLog,
  networkLog: networkLog,
  networkLoggingLevels: _logLevels["default"]
};
//# sourceMappingURL=index.js.map